<template>
  <div class="container">
    <recibo :base64="receipt" />
  </div>
</template>

<script>
import Recibo from '@/components/ReciboBase64';
import { mapState } from 'vuex';

export default {
  components: {
    Recibo,
  },
  computed: {
    ...mapState({
      receipt: (state) => state.predio.recibo,
    }),
  },
};
</script>

<style lang="scss" scoped>
.container {
  justify-content: center;
}
</style>
